import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';

export const HoldCountdown = ({ expiresAt, onExpire }) => {
  const [left, setLeft] = useState(null);

  useEffect(() => {
    if (!expiresAt) return;
    const end = new Date(expiresAt).getTime();
    const tick = () => {
      const ms = end - Date.now();
      setLeft(Math.max(0, ms));
      if (ms <= 0) { clearInterval(id); onExpire(); }
    };
    const id = setInterval(tick, 1000);
    tick();
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expiresAt]);

  if (left === null) return null;
  const mins = Math.floor(left / 60000);
  const secs = Math.floor((left % 60000) / 1000);
  const urgent = left < 120000;
  return (
    <div data-testid="hold-countdown"
      className={`flex items-center gap-2 px-4 py-2 mb-4 text-sm border transition-colors ${urgent ? 'bg-red-50 border-red-200 text-red-700' : 'bg-[#fdf8ec] border-[#ecd9a8] text-[#7a5a0b]'}`}>
      <Clock size={16} />
      Slot held for <span className="font-semibold tabular-nums" data-testid="hold-countdown-time">{mins}:{String(secs).padStart(2, '0')}</span>
    </div>
  );
};
